import React from "react";

import AreaHealthMap from "./areaHealth/Map";
import CannibalisationMap from "./cannibalisation/Map";
import CompetitionMap from "./competition/Map";
import CompetitionNewMap from "./competitionNew/Map";
import DemographicsMap from "./demographics/Map";
import FootfallMap from "./footfall/Map";
import FootfallNewMap from "./footfallNew/Map";
import LandingMap from "./landing/Map";
import Overview from "./overview/Map";
import RetailersMap from "./retailers/Map";
import SpendMap from "./spend/Map";
import SpendNewMap from "./spendNew/Map";

import { useAppSelector } from "store";
import {
    selectIsInsightVisible,
    selectCurrentChapter,
    LocationChapter
} from "modules/customer/tools/location/locationSlice";
import { selectFeatureFlags } from "modules/featureFlags/featureFlagsSlice";

const Map: React.FC = () => {
    const isInsightVisible = useAppSelector(selectIsInsightVisible);
    const featureFlags = useAppSelector(selectFeatureFlags);
    const enableCompetitionNew = featureFlags.enableCustomerToolsLocationCompetitionNew;
    const enableSpendNew = featureFlags.enableCustomerToolsLocationSpendNew;
    const enableRetailers = featureFlags.enableCustomerToolsLocationRetailers;
    const enableFootfallNew = featureFlags.enableCustomerToolsLocationFootfallNew;
    const currentChapter = useAppSelector(selectCurrentChapter);

    if (!isInsightVisible) {
        return (
            <LandingMap />
        );
    }

    switch (currentChapter) {
        case LocationChapter.Overview:
            return <Overview />;
        case LocationChapter.Demographics:
            return <DemographicsMap />;
        case LocationChapter.Spend:
            return enableSpendNew ? < SpendNewMap /> : <SpendMap />;
        case LocationChapter.Competition:
            return enableCompetitionNew ? <CompetitionNewMap /> : <CompetitionMap />;
        case LocationChapter.AreaHealth:
            return enableRetailers ? < RetailersMap /> : <AreaHealthMap />;
        case LocationChapter.Footfall:
            return enableFootfallNew ? < FootfallNewMap /> : <FootfallMap />;
        case LocationChapter.Cannibalisation:
            return <CannibalisationMap />;
        default:
            return <></>;
    }
};

export default Map;
